// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/message/style/index.less
// module id = 1051
// module chunks = 1